export const dealers = {
  "dealers.getDealers": "dealers.getDealers",
} as const;
